// extracted by mini-css-extract-plugin
export default {"customField":"CustomExtendedDataField_customField__qwZyL","curencyFields":"CustomExtendedDataField_curencyFields__gwZ2e","curency":"CustomExtendedDataField_curency__hbjd0"};